import styled from "styled-components"


export const FooterBox = styled.div`
margin-top: 90px;
text-align: center;
opacity: .4;
`